<template>
  <!-- 2カラムページの場合は'is-2column'クラスを付与 -->
  <!-- ヘッダーを隠すの場合は'is-hidden-header'クラスを付与 -->
  <div id="body" class="responsive">
  <BackgroundImage />

    <div id="wrapper">
      <div id="head-logo">
        <router-link to="/pc/login" target="_blank">
          <img src="/lc/app/images/log-1row.svg" alt="LEGAL CONNECTION">
        </router-link>
      </div>
      <!-- content:start -->
      <div id="content">
        <div class="contact">
          <div class="contact-head">
            <div class="breadcrumb">
              <span class="breadcrumb-link">パスワード変更</span>
              <span class="breadcrumb-link current">パスワード変更の完了</span>
            </div>
            <h1 class="hdg02">パスワード変更の完了</h1>
          </div>
          <div class="contact-container">
            <div class="contact-content">
              <p class="txt mb40">パスワードを変更しました。ログイン画面より、ログインしてください。</p>
              
              <div class="contact-submit mb40">
                <div class="button contact-submit-button">
                  <router-link to="/pc/login" class="btn" role="button">ログイン画面へ</router-link>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <!-- content:end -->
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted } from '@vue/composition-api'
// import '@/components/style/RESCommonCSS.vue'

export default defineComponent({
  components: {
  },
  setup (props, context) {

    const group1 = reactive({
    })
    return {
      group1
    }
  }
})
</script>

<style lang="scss" scoped>

</style>
